
import Messages1 from "../../../assets/filled/Messages1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Messages1Icon({ className, dataTestid = "Messages1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Messages1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
